import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Hero } from "../components/Hero";
import { PredictionForm } from "../components/PredictionForm";
import { PairPredictionForm } from "../components/PairPredictionForm";
import { LoadingState } from "../components/LoadingState";
import { Results } from "../components/Results";
import { PairResults } from "../components/PairResults";
import { BrandMark } from "../components/BrandMark";
import { Footer } from "../components/Footer";
import { fetchPrediction, fetchPairPrediction } from "../lib/api";

const VIEWS = {
  HERO: "hero",
  FORM: "form",
  PAIR_FORM: "pair_form",
  LOADING: "loading",
  RESULTS: "results",
  PAIR_RESULTS: "pair_results",
};

export const HomePage = () => {
  const [view, setView] = useState(VIEWS.HERO);
  const [result, setResult] = useState(null);
  const [pairResult, setPairResult] = useState(null);

  useEffect(() => {
    document.title = "Astrarium · Free Astrology Reading by Date of Birth";
  }, []);

  const handleSubmit = async (payload) => {
    setView(VIEWS.LOADING);
    try {
      const data = await fetchPrediction(payload);
      setResult({ ...data, _meta: payload });
      setView(VIEWS.RESULTS);
    } catch (e) {
      console.error(e);
      toast.error("The wheel is clouded. Please try again in a moment.");
      setView(VIEWS.FORM);
    }
  };

  const handlePairSubmit = async (payload) => {
    setView(VIEWS.LOADING);
    try {
      const data = await fetchPairPrediction(payload);
      setPairResult(data);
      setView(VIEWS.PAIR_RESULTS);
    } catch (e) {
      console.error(e);
      toast.error("The wheel is clouded. Please try again in a moment.");
      setView(VIEWS.PAIR_FORM);
    }
  };

  const handleRestart = () => {
    setResult(null);
    setPairResult(null);
    setView(VIEWS.HERO);
  };

  return (
    <>
      {view !== VIEWS.HERO && (
        <header className="fixed top-0 left-0 right-0 z-30 px-6 py-5 flex items-center justify-center pointer-events-none">
          <div className="pointer-events-auto">
            <BrandMark onClick={handleRestart} />
          </div>
        </header>
      )}
      <main className="relative z-10" data-testid="app-root">
        {view === VIEWS.HERO && (
          <Hero
            onBegin={() => setView(VIEWS.FORM)}
            onBeginPair={() => setView(VIEWS.PAIR_FORM)}
          />
        )}
        {view === VIEWS.FORM && (
          <PredictionForm onSubmit={handleSubmit} onBack={() => setView(VIEWS.HERO)} />
        )}
        {view === VIEWS.PAIR_FORM && (
          <PairPredictionForm onSubmit={handlePairSubmit} onBack={() => setView(VIEWS.HERO)} />
        )}
        {view === VIEWS.LOADING && <LoadingState />}
        {view === VIEWS.RESULTS && <Results data={result} onRestart={handleRestart} />}
        {view === VIEWS.PAIR_RESULTS && <PairResults data={pairResult} onRestart={handleRestart} />}
      </main>
      {(view === VIEWS.HERO || view === VIEWS.RESULTS || view === VIEWS.PAIR_RESULTS) && <Footer />}
    </>
  );
};
